/* esm.sh - rxjs@7.8.1/dist/esm/internal/operators/mergeAll */
import{mergeMap as t}from"./mergeMap.mjs";import{identity as e}from"../util/identity.mjs";function n(r=1/0){return t(e,r)}export{n as mergeAll};
//# sourceMappingURL=mergeAll.mjs.map